import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/app.css';

// Force default locale if provided via Vite env variable
const defaultLocale = import.meta.env.VITE_DEFAULT_LOCALE || '';
if (defaultLocale) {
  try {
    // set HTML lang attribute for accessibility and proper locale
    document.documentElement.lang = defaultLocale;

    // For some libraries and built-in Intl formatting, you may want to set locale on the window
    // We expose it as window.__DEFAULT_LOCALE__ so other modules can read it if needed
    (window as any).__DEFAULT_LOCALE__ = defaultLocale;

    // Optionally, for date formatting helpers, you can set the default locale on Intl via a wrapper in your components.
    // Native Intl uses the locale you pass to methods like toLocaleDateString; no global override exists.
  } catch (e) {
    // ignore
  }
}

createRoot(document.getElementById('root') as HTMLElement).render(<App />);
